

angular
.module('inkfinder')
.factory('MergeProjects', function MergeProjects(
  Projects,
  _
) {
  // Public methods
  MergeProjects.merge = merge;
  /**
   * @name merge
   * @description Function to call and merge projects with appointments.
   * @param {array} appointments The array of appointments to merge projects with.
   * @return {array} MergeProjects Returns the grouped collection.
   */
  function merge(appointments) {
    if (appointments.length > 0) {
      let projectIds = _.map(appointments, function(appointment) {
        return appointment.project;
      }).join(',');
      return Projects.get(projectIds).then(function(projects) {
        let mergedAppointments = [];
        _.each(appointments, function(appointment) {
          let data = {};
          data.appointment = appointment;
          data.project = _.find(projects, function(project) {
            if (appointment.project === project.id) {
              return true;
            }
          });
          mergedAppointments.push(data);
        });
        return mergedAppointments;
      });
    }
  }
  return MergeProjects;
});



// WEBPACK FOOTER //
// ./components/appointments/util/merge-projects.service.js